let isEditing = (window as any).__editing === true;
export const isInsideHtmlEditor = (e: HTMLElement) => (isEditing ??= (document.body.hasAttribute("editing") || e && e.isContentEditable));